import apiClient from '@/shared/lib/apiClient';

/** `POST /api/demo-requests`: il server avvisa il team e, se configurato, lo annota nel foglio. */
export async function submitDemoRequest(lead) {
  const res = await apiClient.post('/demo-requests', lead);
  return res.data;
}
